class ProductOptionModal {
  constructor(modalId) {
    this.modalId = modalId;
    this.modal = null;
    this.openButton = null;
    this.closeButton = null;
    this.focusedElementBeforeModal = null;
    this.init();
  }

  init() {
    this.modal = document.getElementById(this.modalId);
    this.openButton = document.querySelector(`[aria-controls="${this.modalId}"]`);
    this.closeButton = this.modal?.querySelector('.product-option-modal__close');

    if (!this.modal || !this.openButton || !this.closeButton) return;

    this.setupEventListeners();
    this.setupFocusTrap();
  }

  setupEventListeners() {
    // モーダルを開く
    this.openButton.addEventListener('click', () => this.open());

    // モーダルを閉じる
    this.closeButton.addEventListener('click', () => this.close());

    // 背景クリックで閉じる
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.close();
      }
    });

    // Escapeキーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.close();
      }
    });

    // オプション選択時の処理
    const optionInputs = this.modal.querySelectorAll('input[type="radio"]');
    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateSelectedOption(input);
        if (this.modal.dataset.bundle !== 'true') {
          setTimeout(() => this.close(), 300);
        }
      });
    });
  }

  open() {
    this.focusedElementBeforeModal = document.activeElement;
    this.modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // 最初のフォーカス可能な要素にフォーカス
    setTimeout(() => {
      this.closeButton.focus();
    }, 100);

    // ARIA属性の更新
    this.openButton.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.modal.classList.remove('is-active');
    document.body.style.overflow = '';

    // フォーカスを戻す
    if (this.focusedElementBeforeModal) {
      this.focusedElementBeforeModal.focus();
    }

    // ARIA属性の更新
    this.openButton.setAttribute('aria-expanded', 'false');
  }

  updateSelectedOption(input) {
    const optionValue = input.value;
    const optionName = input.name;

    // ボタンのテキストを更新
    const buttonText = this.openButton.querySelector('.option-modal-button__text');
    if (buttonText) {
			const optionName = this.openButton.dataset.optionName;
      buttonText.textContent = optionName + ' ' + optionValue;
    }

    // オプション名の表示を更新（存在する場合）
    const optionDisplay = document.getElementById(`product${optionName}Name`);
    if (optionDisplay) {
      optionDisplay.textContent = optionValue;
    }

    const bisTriggerSize = input.getAttribute('data-bis-trigger');
    const variantId = input.getAttribute('data-variant-id');
    if (bisTriggerSize === 'true') {
      BIS.popup.show({ variantId: variantId });
    }
  }

  setupFocusTrap() {
    const focusableElements = this.modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;

    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    this.modal.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    });
  }
}

// 複数のモーダルを管理するクラス
class ProductOptionModalsManager {
  constructor() {
    this.modals = [];
    this.init();
  }

  init() {
    // すべてのオプションモーダルを検索
    const modalElements = document.querySelectorAll('.product-option-modal');
    
    modalElements.forEach((modalElement) => {
      const modalId = modalElement.id;
      if (modalId) {
        const modal = new ProductOptionModal(modalId);
        this.modals.push(modal);
      }
    });
  }
}

// 初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductOptionModalsManager();
  });
} else {
  new ProductOptionModalsManager();
}

